/* eslint-disable react/forbid-prop-types */
import 'url-search-params-polyfill';

import React from 'react';

import { Divider, Card, Button } from 'antd';
import Errors from './errors';
import * as productValues from '../../../components/DibbsTabs/options';

const displayData = (value, location = null) => {
  if (!value) {
    return '-';
  }
  if (value && !location) {
    return value;
  } else if (productValues[location][value]) {
    return `${productValues[location][value]} `;
  }
  return '-';
};

const Header = block => {
  const { data, changeMenu, validation } = block;
  console.log(data);

  const getFldNameKey = validationArray => {
    const keys = {};
    validationArray.forEach((element, i) => {
      keys[element.fldName] = i;
    });
    return keys;
  };

  const validatationKeys = getFldNameKey(validation);

  const createItems = arr =>
    arr.map(productObj => {
      console.log(productObj);
      return (
        <div>
          <Divider orientation="left">{productObj.nsnOrPn}</Divider>
          <div className="tab-wrapper-small">
            {' '}
            <p>Nomenclature: {productObj.nomenclature}</p>
          </div>
          <div className="inline">
            Item Description Indicator:{' '}
            <p>{displayData(productObj.itemDescription, 'itemDescription')}</p>
          </div>
          <div className="inline">
            <div>
              Part Number Offered - Code:{' '}
              <p>{displayData(productObj.partNumOffrd, 'pnOfferedCode')}</p>
            </div>
            <div>
              Part Number offered – CAGE Code:{' '}
              <p>{displayData(productObj.pnOffrdCage)}</p>
            </div>
            <div>
              Part Number Offered – Part Number:{' '}
              <p>{displayData(productObj.pnOffrdPartNum)}</p>
            </div>
          </div>
          {validatationKeys && validatationKeys.partNumOffrd ? (
            <Errors validation={validation[validatationKeys.partNumOffrd]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.pnOffrdCage ? (
            <Errors validation={validation[validatationKeys.pnOffrdCage]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.pnOffrdPartNum ? (
            <Errors validation={validation[validatationKeys.pnOffrdPartNum]} />
          ) : (
            <div />
          )}
          <div className="inline">
            <div>
              Part Number Offered Remarks:{' '}
              <p>{displayData(productObj.pnOffrdRmks)}</p>
            </div>
          </div>
          <div className="inline">
            Supplies Offered: <p>{displayData(productObj.suppOffrd)}</p>
          </div>
          {validatationKeys && validatationKeys.suppOffrd ? (
            <Errors validation={validation[validatationKeys.suppOffrd]} />
          ) : (
            <div />
          )}
          <div className="inline">
            Supplies Offered Remarks:{' '}
            <p>{displayData(productObj.suppOffrdRmks)}</p>
          </div>
          <div className="inline">
            <div>
              Higher-Level Quality:{' '}
              <p>{displayData(productObj.highLevQualInd, 'higherLevel')}</p>
            </div>
            <div>
              Higher-Level Quality Code:{' '}
              <p>{displayData(productObj.highLevQualCd, 'higherAll')}</p>
            </div>
            <div>
              Other Higher-Level Quality Standard/System:{' '}
              <p>{displayData(productObj.highLevQualRmks)}</p>
            </div>
          </div>
          {validatationKeys && validatationKeys.highLevQualInd ? (
            <Errors validation={validation[validatationKeys.highLevQualInd]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.highLevQualCd ? (
            <Errors validation={validation[validatationKeys.highLevQualCd]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.highLevQualRmks ? (
            <Errors validation={validation[validatationKeys.highLevQualRmks]} />
          ) : (
            <div />
          )}
          <div className="inline">
            Trade Agreements Indicator:{' '}
            <p>{displayData(productObj.trdAgmtsInd, 'tradeIndicator')}</p>
          </div>
          {validatationKeys && validatationKeys.trdAgmtsInd ? (
            <Errors validation={validation[validatationKeys.trdAgmtsInd]} />
          ) : (
            <div />
          )}
          <div className="inline">
            Manafacturer/Dealer:{' '}
            <p>{displayData(productObj.manufDlr, 'manufacturer')}</p>
          </div>
          {validatationKeys && validatationKeys.manufDlr ? (
            <Errors validation={validation[validatationKeys.manufDlr]} />
          ) : (
            <div />
          )}
          <div className="inline">
            <div>
              source CAGE code: <p>{displayData(productObj.manufCage)}</p>
            </div>
            <div>
              Source Name and Address:{' '}
              <p>{displayData(productObj.manufNmAddr)}</p>
            </div>
          </div>
          {validatationKeys && validatationKeys.manufCage ? (
            <Errors validation={validation[validatationKeys.manufCage]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.manufNmAddr ? (
            <Errors validation={validation[validatationKeys.manufNmAddr]} />
          ) : (
            <div />
          )}

          <div className="inline">
            Material Requirements:{' '}
            <p>{displayData(productObj.matRqmts, 'matType')}</p>
          </div>
          {validatationKeys && validatationKeys.matRqmts ? (
            <Errors validation={validation[validatationKeys.matRqmts]} />
          ) : (
            <div />
          )}
          <div className="inline">
            <div>
              Buy American:{' '}
              <p>{displayData(productObj.buyAmrcnInd, 'buyAmerican')}</p>
            </div>
            <div>
              Free Trade Agreements:{' '}
              <p>{displayData(productObj.freeTrdAgmts, 'freeTrade')}</p>
            </div>
            <div>
              {' '}
              Source of Supply CAGE code:{' '}
              <p>{displayData(productObj.sosCage)}</p>
            </div>
          </div>
          {validatationKeys && validatationKeys.buyAmrcnInd ? (
            <Errors validation={validation[validatationKeys.buyAmrcnInd]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.freeTrdAgmts ? (
            <Errors validation={validation[validatationKeys.freeTrdAgmts]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.sosCage ? (
            <Errors validation={validation[validatationKeys.sosCage]} />
          ) : (
            <div />
          )}
          <div>
            <div />
          </div>

          <div className="inline">
            <div>
              {' '}
              Hazardous Material Identification and Material Safety Data:{' '}
              <p>{displayData(productObj.hazMatMsd, 'hazmat')}</p>
            </div>
            <div>
              Hazardous Warning Labels:{' '}
              <p>{displayData(productObj.hazMatWarning)}</p>
            </div>
          </div>
          {validatationKeys && validatationKeys.hazMatMsd ? (
            <Errors validation={validation[validatationKeys.hazMatMsd]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.hazMatWarning ? (
            <Errors validation={validation[validatationKeys.hazMatWarning]} />
          ) : (
            <div />
          )}
          <div className="inline">
            <div>
              Quantity available for immediate shipment:{' '}
              <p>{productObj.quantityAvailable}</p>
            </div>
            <div>
              Quantity Price: <p> {productObj.quantityPrice}</p>
            </div>
            <div>
              Delivery Days: <p> {productObj.dlvyDays}</p>
            </div>
          </div>
          {validatationKeys && validatationKeys.minOrderQnty ? (
            <Errors validation={validation[validatationKeys.minOrderQnty]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.quantityPrice ? (
            <Errors validation={validation[validatationKeys.quantityPrice]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.dlvyDays ? (
            <Errors validation={validation[validatationKeys.dlvyDays]} />
          ) : (
            <div />
          )}

          <div className="inline">
            <div>
              Qualification Requirements MFG CAGE:{' '}
              <p>{displayData(productObj.qualReqMfgCage)}</p>
            </div>
            <div>
              Source CAGE: <p>{displayData(productObj.qualReqSrcCage)}</p>
            </div>
            <div>
              Item Name: <p>{displayData(productObj.qualReqItemNm)}</p>
            </div>
          </div>
          {validatationKeys && validatationKeys.qualReqMfgCage ? (
            <Errors validation={validation[validatationKeys.qualReqMfgCage]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.qualReqSrcCage ? (
            <Errors validation={validation[validatationKeys.qualReqSrcCage]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.qualReqItemNm ? (
            <Errors validation={validation[validatationKeys.qualReqItemNm]} />
          ) : (
            <div />
          )}
          <div className="inline">
            <div>
              Qualification Requirements Service Identification:{' '}
              <p>{displayData(productObj.qualReqSvcId)}</p>
            </div>
            <div>
              Test Number: <p>{displayData(productObj.qualReqTstNum)}</p>
            </div>
          </div>
          {validatationKeys && validatationKeys.qualReqSvcId ? (
            <Errors validation={validation[validatationKeys.qualReqSvcId]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.qualReqTstNum ? (
            <Errors validation={validation[validatationKeys.qualReqTstNum]} />
          ) : (
            <div />
          )}
        </div>
      );
    });

  return (
    <div className="subcomponent-wrapper">
      <div className="subcomponent-header">Product </div>
      <Card>
        {createItems(data)}
        <div className="edit-button-dibbs">
          <Button
            type="primary"
            onClick={() => {
              changeMenu('product');
            }}
          >
            Edit
          </Button>
        </div>
      </Card>
      <Divider />
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/reviewComponents/product.jsx